module.exports = __webpack_public_path__ + "static/media/overlay_logos.3f8ae6e8.png";